// eslint-disable-next-line no-restricted-globals
export default (typeof self === "object" && self.self === self && self) ||
  (typeof global === "object" && global.global === global && global) ||
  this
